var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandidateNotActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 64,
    viewBox: "0 0 46 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0.0268704C19.9447 -0.132724 16.8932 0.419925 14.0408 1.64944C11.1883 2.87896 8.59783 4.75825 6.43506 7.16702C4.2723 9.57579 2.58493 12.461 1.48099 15.6379C0.37704 18.8147 -0.119169 22.2133 0.0241262 25.6161C0.0241262 33.6767 5.76809 41.6094 8.64008 44.8081C11.5121 48.0067 23 64 23 64C23 64 34.4879 48.0067 37.3599 44.8081C40.2319 41.6094 45.9759 33.6767 45.9759 25.6161C46.1192 22.2133 45.623 18.8147 44.519 15.6379C43.4151 12.461 41.7277 9.57579 39.5649 7.16702C37.4022 4.75825 34.8117 2.87896 31.9592 1.64944C29.1068 0.419925 26.0553 -0.132724 23 0.0268704Z",
    fill: "#B7483B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 19,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 12C22.2809 12 21.1117 12.5035 20.2496 13.3997C19.3875 14.2958 18.9032 15.5113 18.9032 16.7787C18.9032 18.0461 19.3875 19.2616 20.2496 20.1578C21.1117 21.054 22.2809 21.5575 23.5 21.5575C24.7191 21.5575 25.8883 21.054 26.7504 20.1578C27.6125 19.2616 28.0968 18.0461 28.0968 16.7787C28.0968 15.5113 27.6125 14.2958 26.7504 13.3997C25.8883 12.5035 24.7191 12 23.5 12ZM18.5968 24.1061C17.3776 24.1061 16.2084 24.6096 15.3464 25.5058C14.4843 26.402 14 27.6175 14 28.8849V30.3988C14 31.3596 14.6693 32.1777 15.5813 32.3319C20.8253 33.2227 26.1747 33.2227 31.4187 32.3319C31.8598 32.2565 32.2608 32.0208 32.5503 31.6668C32.8399 31.3128 32.9993 30.8635 33 30.3988V28.8849C33 27.6175 32.5157 26.402 31.6536 25.5058C30.7916 24.6096 29.6224 24.1061 28.4032 24.1061H27.9865C27.7576 24.107 27.5354 24.1435 27.3196 24.2157L26.2581 24.5764C24.4659 25.1846 22.5341 25.1846 20.7419 24.5764L19.6804 24.2157C19.4652 24.144 19.2407 24.107 19.0148 24.1061H18.5968Z",
    fill: "#B7483B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateNotActive);
export default __webpack_public_path__ + "static/media/candidate_not_active.d8414a989bf1863174301de84be1068c.svg";
export { ForwardRef as ReactComponent };